<template>
<div>
    <transition v-for="popup in popups" :key="popup._id">
        <component :is="skinComponent" :popup="popup"></component>
    </transition>
</div>
</template>

<script>
import api from "@/api";

export default {
    props: {
        skin: { type: String, default: "basic" }
    },
    data(){
        return {
            popups: []
        }
    },
	mounted() {
		this.init();
	},
	methods: {
		async init() {
            var { popups } = await api.v1.popups.gets();
            this.popups = popups;
            console.log(this.popups);
		},
	},
    computed: {
        skinComponent(){
            return () => import(`./skin/${this.$props.skin}/view.vue`);
        }
    }
}
</script>
